import {Lang} from 'yougile-lang'
import {
  DataObjectId,
  PaymentAction,
  PaymentInvoiceReq,
  PaymentInvoiceResp,
  PaymentStatus
} from 'yougile-model'
import {logger} from 'yougile-util'

import {Backend} from '../../common/backend'

export interface Requisites {
  fullName: string
  address: string
  tin: string
  trrc: string
  accNum: string
  corrAccNum: string
  rcbic: string
}

export class WebPay {
  private static addWidgetIfNotAlready(): Promise<void> {
    if ('cp' in window) {
      return Promise.resolve()
    } else {
      const scr = document.createElement('script')
      scr.src = 'https://widget.cloudpayments.ru/bundles/cloudpayments'
      document.body.appendChild(scr)
      return new Promise((resolve, reject) => {
        scr.onload = () => resolve()
        scr.onerror = err => reject(err)
      })
    }
  }

  static async pay(
    companyId: DataObjectId,
    action: PaymentAction,
    paymentStatus: PaymentStatus,
    description: string,
    email: string,
    phone: string,
    recurrentMonths: number
  ): Promise<void> {
    logger.log('Payment action', JSON.stringify(action))
    const req: PaymentInvoiceReq = {
      ...Backend.loadCred(),
      companyId,
      action,
      email,
      phone
    }
    const resp = await Backend.postJSON<PaymentInvoiceResp>(
      '/data/payment/invoice-cloudpayments',
      req
    )
    await this.addWidgetIfNotAlready()
    const cp = (window as any).cp
    const widget = new cp.CloudPayments({
      language: Lang.getLang() === 'en' ? 'en-US' : 'ru-RU'
    })
    const canSubscribe =
      action.type !== 'upgrade' &&
      (!paymentStatus.subscriptions ||
        !paymentStatus.subscriptions.all ||
        paymentStatus.subscriptions.all.length === 0)
    const opts = {
      publicId: resp.publicId,
      description,
      amount: action.amount.amount,
      currency: action.amount.currency,
      invoiceId: resp.invoiceId,
      accountId: companyId,
      email,
      data: {
        companyId,
        action,
        cloudPayments:
          canSubscribe && recurrentMonths
            ? {
                recurrent: {
                  interval: 'Month',
                  period: recurrentMonths
                }
              }
            : undefined
      }
    }
    return new Promise<void>((resolve, reject) => {
      widget.charge(
        opts,
        (res: unknown) => {
          logger.log('SUCCESS', res)
          resolve()
        },
        (reason: unknown) => {
          logger.log('FAIL', reason)
          reject(reason)
        }
      )
    })
  }

  static async requestInvoice(
    companyId: DataObjectId,
    action: PaymentAction,
    email: string,
    phone: string,
    requisites: Requisites
  ): Promise<void> {
    const req: PaymentInvoiceReq = {
      companyId,
      userId: Backend.loadId(),
      key: Backend.loadKey(),
      action,
      email,
      phone,
      ...requisites
    }
    await Backend.postJSON<PaymentInvoiceResp>(
      '/data/payment/invoice-request',
      req
    )
  }
}
